import { ClipBox } from './clip-box.models';

export class SetClipBox {
  static readonly type = '[ClipBox] SetClipBox';
  constructor(public readonly clipBox: ClipBox) {}
}

export class ClearClipBox {
  static readonly type = '[ClipBox] ClearClipBox';
}
